import { CancelToken } from 'axios';

export default instance => new CancelToken(c => (instance = c));



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/createCancelToken.js